var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlux = function SvgFlux(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M12 35.025 30.015 7.75 48 35.025h-3.35L30.015 12.817 17.206 32.209H35.39l1.858 2.816z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "m24.103 29.084 3.109-4.673 3.111 4.673zm15.256 5.938-8.502-13.06h3.266l8.529 13.06zm2.25-13.51 3.195-4.785 3.195 4.785z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    fillOpacity: 0.42,
    d: "M58.156 31.5V11.452h11.466v2.884h-8.4V31.5zm1.694-8.358v-2.758h9.38v2.758zM72.788 31.5V11.452h3.038V31.5zm11.647.448q-2.52 0-3.92-1.47-1.386-1.484-1.386-4.158v-9.17h3.038v8.666q0 1.75.798 2.674.811.924 2.31.924 1.581 0 2.66-1.204 1.078-1.204 1.078-2.912V17.15h3.024V31.5h-2.87v-3.416l1.372 1.386h-1.456q-.615 1.092-1.89 1.792-1.26.686-2.758.686m19.827-.448-4.2-6.398h-.42l-5.628-7.952h3.43l4.312 6.384.322.014 5.614 7.952zm-10.388 0 5.754-8.204h.602l4.13-6.146h3.332l-5.67 7.896h-.532L97.164 31.5z"
  })));
};
export default SvgFlux;